/* RESPONSIBLE TEAM: team-standalone */

import type { ConversationExcerptData } from '../definitions';
import type ZendeskPlatform from '../../zendesk';

export default class ZendeskConversationExcerpt implements ConversationExcerptData {
  private platform: ZendeskPlatform;

  constructor(platform: ZendeskPlatform) {
    this.platform = platform;
  }

  title(excerptsEnabled: boolean) {
    let defaultPrefix = 'fin-ai-agent.knowledge.content-sources.conversation-excerpts';
    let prefix = excerptsEnabled ? `${defaultPrefix}.enabled` : defaultPrefix;
    return this.platform.intl.t(`${prefix}.zendesk`);
  }

  get link() {
    return this.platform.zendeskConfig?.fullZendeskUrl;
  }
}
